import { createFileRoute } from "@tanstack/react-router";
import { FixedLayout } from "@/components/shared/fixed-layout";

const PARENT_VERIFICATION_TITLE = "보호자 본인 인증";

function ParentKMCVerificationPage() {
  return (
    <FixedLayout
      headerType="back"
      title={PARENT_VERIFICATION_TITLE}
      showButton={false}
    >
      <div className="size-full flex flex-col items-center justify-center">
        본인인증 모듈 영역
      </div>
    </FixedLayout>
  );
}

export const Route = createFileRoute("/auth/signup/parent-kmc-verification")({
  component: ParentKMCVerificationPage,
});
